export * as default from "./alertDialog.service";
export type { AlertDialogOptions } from "./alertDialog.service";
